import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-orange/25" data-id="element-0" data-mp="23w4ey1znd61d">
      <AnnouncementBar data-id="element-1" data-mp="3iiwasc8k4vxf" />
      <main data-id="element-2" data-mp="3ijpcuzwkmx98">
        <HeroSection data-id="element-3" data-mp="3ii4t85bsoyq5" />
        <StatsBar data-id="element-4" data-mp="3mlaxx8j9ehui" />
        <TransformationSection data-id="element-5" data-mp="3mkrc3gqhn9b7" />
        <PainPointsSection data-id="element-6" data-mp="3mjzpgvevclx2" />
        <KitContentsSection data-id="element-7" data-mp="3mj6lu3b7icj5" />
        <InstantAccessSection data-id="element-8" data-mp="3rbzn2h7gv2qh" />
        <BonusesSection data-id="element-9" data-mp="3rcsyvwla8ifh" />
        <PricingSection data-id="element-10" data-mp="3reltuemj9e7n" />
        <GuaranteeSection data-id="element-11" data-mp="5os92t1uy7l" />
        <TestimonialsSection data-id="element-12" data-mp="4wwnrzgd0hb" />
        <FAQSection data-id="element-13" data-mp="56qjqnmbrsa" />
        <FinalCTASection data-id="element-14" data-mp="2zl3a7gleoy37" />
      </main>
      <Footer data-id="element-15" data-mp="2zm4yimrfnh2v" />
    </div>;
}